import { Cell } from "./types";

type Interval = [number, number];

const sortIntervals = (a: Interval, b: Interval): number =>
  a[0] === b[0] ? a[1] - b[1] : a[0] - b[0];

const mergeIntervals = (input: Array<Interval>): Array<Interval> => {
  if (input.length < 1) {
    return input;
  }
  const toReturn: Array<Interval> = [];
  const sorted = input.sort(sortIntervals);
  let currentInterval = sorted[0];
  for (let i = 1; i < sorted.length; i++) {
    if (currentInterval[1] > sorted[i][0]) {
      currentInterval = [currentInterval[0], Math.max(currentInterval[1], sorted[i][1])];
      continue;
    }
    toReturn.push(currentInterval);
    currentInterval = sorted[i];
  }
  toReturn.push(currentInterval);
  return toReturn;
};

export const selectedSegments = (cells: ReadonlyArray<Cell>): Array<Interval> => {
  const intervals = mergeIntervals(
    cells.reduce((prev, cell) => {
      switch (cell.selectedBorder) {
        case "bottom":
        case "top":
          prev.push([cell.minX, cell.maxX]);
          break;
        case "left":
        case "right":
          prev.push([cell.minY, cell.maxY]);
          break;
      }
      return prev;
    }, [] as Array<Interval>),
  );
  return intervals;
};
